import { Box } from "@mui/material";
import { GridPaginationModel, GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
// import Flex from "../../../../../../../components/Flex";
import LabeledSwitch from "../../../../../../../components/LabeledSwitch";
import { ChartActionStrip } from "../../../../../../../components/app/provider/patient/chart";
import useSelectedPatient from "../../../../../../../hooks/local-storage/use-selected-patient";
import { useDebounce } from "../../../../../../../hooks/use-debounce";
import { useListReferral } from "../../../../../../../queries/collaboration/referral/use-list-referral";
import { DEF_PAGINATION, getXtenantId } from "../../../../../../../utils/utils";
import {
  DEFAULT_FILTERS,
  REFERRAL_FILTER_INITIAL_EXPANDED,
  REFERRAL_INITIAL_VALUES,
  ReferralFilters,
} from "../../../../collabration/collaboration-referral-constant";
import { ReferralEndActions } from "../../../../collabration/referrals/ReferralTopBar";
import PatientReferralNew from "./PatientReferralNew";
import useCurrentUser from "../../../../../../../hooks/local-storage/use-current-user";

const PatientReferral = () => {
  const [selectedPatient] = useSelectedPatient();
  const [archive, setArchive] = useState(false);
  const [me] = useCurrentUser();
  const patientName = `${selectedPatient?.firstName} ${selectedPatient?.lastName}`;

  const patientData = {
    label: patientName,
    value: selectedPatient?.uuid,
  };

  const [searchStringKey, setSearchStringKey, instantSearchVal] =
    useDebounce<string>("");
  const [pagination, setPagination] =
    useState<GridPaginationModel>(DEF_PAGINATION);
  const [referralFilter, setReferralFilter] =
    useState<ReferralFilters>(DEFAULT_FILTERS);

  const [expanded, setExpanded] = useState<Record<string, boolean>>(
    REFERRAL_FILTER_INITIAL_EXPANDED
  );
  const [referralGridSorting, setReferralGridSorting] = useState<
    GridSortItem[]
  >([]);

  const {
    data: referral,
    isFetching,
    refetch,
  } = useListReferral({
    pagination: pagination,
    active: true,
    referralDate: referralFilter.date
      ? new Date(referralFilter.date).toISOString()
      : undefined,
    referralFrom: referralFilter.referral_from
      ? Object.keys(referralFilter.referral_from)[0]
      : undefined,
    referralTo: referralFilter.referral_to
      ? Object.keys(referralFilter.referral_to)[0]
      : undefined,
    referralSpeciality: referralFilter.speciality
      ? Object.keys(referralFilter.speciality)[0]
      : undefined,
    gridSorting: referralGridSorting,
    referralIn:
      referralFilter.show_referral_in_out === "referral-in"
        ? true
        : referralFilter.show_referral_in_out === "referral-out"
          ? false
          : undefined,
    archive: archive,
    searchString: searchStringKey,
    xTENANTID: getXtenantId(),
    patientId: patientData?.value ?? undefined,
  });

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ChartActionStrip
        startContent={
          <LabeledSwitch
            label="Show Archived"
            checked={archive}
            onChange={(e) => setArchive(e.target.checked)}
            sx={{ paddingX: "8px" }}
          />
        }
        endContent={
          <ReferralEndActions
            setFilters={setReferralFilter}
            filters={referralFilter}
            activeReferral="referral-out"
            setExpanded={setExpanded}
            expanded={expanded}
            searchStringKey={instantSearchVal}
            setSearchStringKey={setSearchStringKey}
            showReferralInOutfilter={true}
            referringOutFromEncounter={true}
            prefillReferralOutData={{
              ...REFERRAL_INITIAL_VALUES,
              patient: patientData,
              referralFrom: {
                value: me?.uuid,
                label: me?.firstName + " " + me?.lastName,
              },
            }}
            hideFilters={true}
            patientData={patientData}
          />
        }
      />

      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <PatientReferralNew
          referral={referral}
          isFetching={isFetching}
          refetch={refetch}
          pagination={pagination}
          setPagination={setPagination}
          referralGridSorting={referralGridSorting}
          setReferralGridSorting={setReferralGridSorting}
        />
      </Box>
    </Box>
  );
};

export default PatientReferral;
